module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "tftable",
    attrs: {
      "id": "tfhover",
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "7"
    }
  }, [_vm._v("一、一般计税方法计税")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("全部征税项目")]), _vm._v(" "), _c('td', [_vm._v("13%税率的货物及加工修理修配劳务")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_1),
      expression: "A_1_1"
    }],
    domProps: {
      "value": (_vm.A_1_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_2),
      expression: "A_1_2"
    }],
    domProps: {
      "value": (_vm.A_1_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_3),
      expression: "A_1_3"
    }],
    domProps: {
      "value": (_vm.A_1_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_4),
      expression: "A_1_4"
    }],
    domProps: {
      "value": (_vm.A_1_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_5),
      expression: "A_1_5"
    }],
    domProps: {
      "value": (_vm.A_1_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_6),
      expression: "A_1_6"
    }],
    domProps: {
      "value": (_vm.A_1_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_7),
      expression: "A_1_7"
    }],
    domProps: {
      "value": (_vm.A_1_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_8),
      expression: "A_1_8"
    }],
    domProps: {
      "value": (_vm.A_1_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_9),
      expression: "A_1_9"
    }],
    domProps: {
      "value": (_vm.A_1_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_10),
      expression: "A_1_10"
    }],
    domProps: {
      "value": (_vm.A_1_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_11),
      expression: "A_1_11"
    }],
    domProps: {
      "value": (_vm.A_1_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_12),
      expression: "A_1_12"
    }],
    domProps: {
      "value": (_vm.A_1_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_13),
      expression: "A_1_13"
    }],
    domProps: {
      "value": (_vm.A_1_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_14),
      expression: "A_1_14"
    }],
    domProps: {
      "value": (_vm.A_1_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("13%税率的服务、不动产和无形资产")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_1),
      expression: "A_2_1"
    }],
    domProps: {
      "value": (_vm.A_2_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_2),
      expression: "A_2_2"
    }],
    domProps: {
      "value": (_vm.A_2_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_3),
      expression: "A_2_3"
    }],
    domProps: {
      "value": (_vm.A_2_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_4),
      expression: "A_2_4"
    }],
    domProps: {
      "value": (_vm.A_2_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_5),
      expression: "A_2_5"
    }],
    domProps: {
      "value": (_vm.A_2_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_6),
      expression: "A_2_6"
    }],
    domProps: {
      "value": (_vm.A_2_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_7),
      expression: "A_2_7"
    }],
    domProps: {
      "value": (_vm.A_2_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_8),
      expression: "A_2_8"
    }],
    domProps: {
      "value": (_vm.A_2_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_9),
      expression: "A_2_9"
    }],
    domProps: {
      "value": (_vm.A_2_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_10),
      expression: "A_2_10"
    }],
    domProps: {
      "value": (_vm.A_2_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_11),
      expression: "A_2_11"
    }],
    domProps: {
      "value": (_vm.A_2_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_12),
      expression: "A_2_12"
    }],
    domProps: {
      "value": (_vm.A_2_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_13),
      expression: "A_2_13"
    }],
    domProps: {
      "value": (_vm.A_2_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_14),
      expression: "A_2_14"
    }],
    domProps: {
      "value": (_vm.A_2_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("9%税率的货物及加工修理修配劳务")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_1),
      expression: "A_3_1"
    }],
    domProps: {
      "value": (_vm.A_3_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_2),
      expression: "A_3_2"
    }],
    domProps: {
      "value": (_vm.A_3_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_3),
      expression: "A_3_3"
    }],
    domProps: {
      "value": (_vm.A_3_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_4),
      expression: "A_3_4"
    }],
    domProps: {
      "value": (_vm.A_3_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_5),
      expression: "A_3_5"
    }],
    domProps: {
      "value": (_vm.A_3_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_6),
      expression: "A_3_6"
    }],
    domProps: {
      "value": (_vm.A_3_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_7),
      expression: "A_3_7"
    }],
    domProps: {
      "value": (_vm.A_3_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_8),
      expression: "A_3_8"
    }],
    domProps: {
      "value": (_vm.A_3_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_9),
      expression: "A_3_9"
    }],
    domProps: {
      "value": (_vm.A_3_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_10),
      expression: "A_3_10"
    }],
    domProps: {
      "value": (_vm.A_3_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_11),
      expression: "A_3_11"
    }],
    domProps: {
      "value": (_vm.A_3_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_12),
      expression: "A_3_12"
    }],
    domProps: {
      "value": (_vm.A_3_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_13),
      expression: "A_3_13"
    }],
    domProps: {
      "value": (_vm.A_3_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_14),
      expression: "A_3_14"
    }],
    domProps: {
      "value": (_vm.A_3_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("9%税率的服务、不动产和无形资产")]), _vm._v(" "), _c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_1),
      expression: "A_4_1"
    }],
    domProps: {
      "value": (_vm.A_4_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_2),
      expression: "A_4_2"
    }],
    domProps: {
      "value": (_vm.A_4_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_3),
      expression: "A_4_3"
    }],
    domProps: {
      "value": (_vm.A_4_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_4),
      expression: "A_4_4"
    }],
    domProps: {
      "value": (_vm.A_4_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_5),
      expression: "A_4_5"
    }],
    domProps: {
      "value": (_vm.A_4_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_6),
      expression: "A_4_6"
    }],
    domProps: {
      "value": (_vm.A_4_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_7),
      expression: "A_4_7"
    }],
    domProps: {
      "value": (_vm.A_4_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_8),
      expression: "A_4_8"
    }],
    domProps: {
      "value": (_vm.A_4_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_9),
      expression: "A_4_9"
    }],
    domProps: {
      "value": (_vm.A_4_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_10),
      expression: "A_4_10"
    }],
    domProps: {
      "value": (_vm.A_4_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_11),
      expression: "A_4_11"
    }],
    domProps: {
      "value": (_vm.A_4_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_12),
      expression: "A_4_12"
    }],
    domProps: {
      "value": (_vm.A_4_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_13),
      expression: "A_4_13"
    }],
    domProps: {
      "value": (_vm.A_4_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_14),
      expression: "A_4_14"
    }],
    domProps: {
      "value": (_vm.A_4_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6%税率")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_1),
      expression: "A_5_1"
    }],
    domProps: {
      "value": (_vm.A_5_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_2),
      expression: "A_5_2"
    }],
    domProps: {
      "value": (_vm.A_5_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_3),
      expression: "A_5_3"
    }],
    domProps: {
      "value": (_vm.A_5_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_4),
      expression: "A_5_4"
    }],
    domProps: {
      "value": (_vm.A_5_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_5),
      expression: "A_5_5"
    }],
    domProps: {
      "value": (_vm.A_5_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_6),
      expression: "A_5_6"
    }],
    domProps: {
      "value": (_vm.A_5_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_7),
      expression: "A_5_7"
    }],
    domProps: {
      "value": (_vm.A_5_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_8),
      expression: "A_5_8"
    }],
    domProps: {
      "value": (_vm.A_5_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_9),
      expression: "A_5_9"
    }],
    domProps: {
      "value": (_vm.A_5_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_10),
      expression: "A_5_10"
    }],
    domProps: {
      "value": (_vm.A_5_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_11),
      expression: "A_5_11"
    }],
    domProps: {
      "value": (_vm.A_5_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_12),
      expression: "A_5_12"
    }],
    domProps: {
      "value": (_vm.A_5_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_13),
      expression: "A_5_13"
    }],
    domProps: {
      "value": (_vm.A_5_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_14),
      expression: "A_5_14"
    }],
    domProps: {
      "value": (_vm.A_5_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("其中：即征即退项目")]), _vm._v(" "), _c('td', [_vm._v("即征即退货物及加工修理修配劳务")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_1),
      expression: "A_6_1"
    }],
    domProps: {
      "value": (_vm.A_6_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_2),
      expression: "A_6_2"
    }],
    domProps: {
      "value": (_vm.A_6_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_3),
      expression: "A_6_3"
    }],
    domProps: {
      "value": (_vm.A_6_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_4),
      expression: "A_6_4"
    }],
    domProps: {
      "value": (_vm.A_6_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_5),
      expression: "A_6_5"
    }],
    domProps: {
      "value": (_vm.A_6_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_6),
      expression: "A_6_6"
    }],
    domProps: {
      "value": (_vm.A_6_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_7),
      expression: "A_6_7"
    }],
    domProps: {
      "value": (_vm.A_6_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_8),
      expression: "A_6_8"
    }],
    domProps: {
      "value": (_vm.A_6_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_9),
      expression: "A_6_9"
    }],
    domProps: {
      "value": (_vm.A_6_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_10),
      expression: "A_6_10"
    }],
    domProps: {
      "value": (_vm.A_6_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_11),
      expression: "A_6_11"
    }],
    domProps: {
      "value": (_vm.A_6_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_12),
      expression: "A_6_12"
    }],
    domProps: {
      "value": (_vm.A_6_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_13),
      expression: "A_6_13"
    }],
    domProps: {
      "value": (_vm.A_6_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_14),
      expression: "A_6_14"
    }],
    domProps: {
      "value": (_vm.A_6_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("即征即退服务、不动产和无形资产")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_1),
      expression: "A_7_1"
    }],
    domProps: {
      "value": (_vm.A_7_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_2),
      expression: "A_7_2"
    }],
    domProps: {
      "value": (_vm.A_7_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_3),
      expression: "A_7_3"
    }],
    domProps: {
      "value": (_vm.A_7_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_4),
      expression: "A_7_4"
    }],
    domProps: {
      "value": (_vm.A_7_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_5),
      expression: "A_7_5"
    }],
    domProps: {
      "value": (_vm.A_7_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_6),
      expression: "A_7_6"
    }],
    domProps: {
      "value": (_vm.A_7_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_7),
      expression: "A_7_7"
    }],
    domProps: {
      "value": (_vm.A_7_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_8),
      expression: "A_7_8"
    }],
    domProps: {
      "value": (_vm.A_7_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_9),
      expression: "A_7_9"
    }],
    domProps: {
      "value": (_vm.A_7_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_10),
      expression: "A_7_10"
    }],
    domProps: {
      "value": (_vm.A_7_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_11),
      expression: "A_7_11"
    }],
    domProps: {
      "value": (_vm.A_7_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_12),
      expression: "A_7_12"
    }],
    domProps: {
      "value": (_vm.A_7_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_13),
      expression: "A_7_13"
    }],
    domProps: {
      "value": (_vm.A_7_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_14),
      expression: "A_7_14"
    }],
    domProps: {
      "value": (_vm.A_7_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "11"
    }
  }, [_vm._v("二、简易计税方法计税")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "9"
    }
  }, [_vm._v("全部征税项目")]), _vm._v(" "), _c('td', [_vm._v("6%征收率")]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_1),
      expression: "A_8_1"
    }],
    domProps: {
      "value": (_vm.A_8_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_2),
      expression: "A_8_2"
    }],
    domProps: {
      "value": (_vm.A_8_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_3),
      expression: "A_8_3"
    }],
    domProps: {
      "value": (_vm.A_8_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_4),
      expression: "A_8_4"
    }],
    domProps: {
      "value": (_vm.A_8_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_5),
      expression: "A_8_5"
    }],
    domProps: {
      "value": (_vm.A_8_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_6),
      expression: "A_8_6"
    }],
    domProps: {
      "value": (_vm.A_8_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_7),
      expression: "A_8_7"
    }],
    domProps: {
      "value": (_vm.A_8_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_8),
      expression: "A_8_8"
    }],
    domProps: {
      "value": (_vm.A_8_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_9),
      expression: "A_8_9"
    }],
    domProps: {
      "value": (_vm.A_8_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_10),
      expression: "A_8_10"
    }],
    domProps: {
      "value": (_vm.A_8_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_11),
      expression: "A_8_11"
    }],
    domProps: {
      "value": (_vm.A_8_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_12),
      expression: "A_8_12"
    }],
    domProps: {
      "value": (_vm.A_8_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_13),
      expression: "A_8_13"
    }],
    domProps: {
      "value": (_vm.A_8_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_14),
      expression: "A_8_14"
    }],
    domProps: {
      "value": (_vm.A_8_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5%征收率的货物及加工修理修配劳务")]), _vm._v(" "), _c('td', [_vm._v("9a")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_1),
      expression: "A_9a_1"
    }],
    domProps: {
      "value": (_vm.A_9a_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_2),
      expression: "A_9a_2"
    }],
    domProps: {
      "value": (_vm.A_9a_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_3),
      expression: "A_9a_3"
    }],
    domProps: {
      "value": (_vm.A_9a_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_4),
      expression: "A_9a_4"
    }],
    domProps: {
      "value": (_vm.A_9a_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_5),
      expression: "A_9a_5"
    }],
    domProps: {
      "value": (_vm.A_9a_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_6),
      expression: "A_9a_6"
    }],
    domProps: {
      "value": (_vm.A_9a_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_7),
      expression: "A_9a_7"
    }],
    domProps: {
      "value": (_vm.A_9a_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_8),
      expression: "A_9a_8"
    }],
    domProps: {
      "value": (_vm.A_9a_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_9),
      expression: "A_9a_9"
    }],
    domProps: {
      "value": (_vm.A_9a_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_10),
      expression: "A_9a_10"
    }],
    domProps: {
      "value": (_vm.A_9a_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_11),
      expression: "A_9a_11"
    }],
    domProps: {
      "value": (_vm.A_9a_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_12),
      expression: "A_9a_12"
    }],
    domProps: {
      "value": (_vm.A_9a_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_13),
      expression: "A_9a_13"
    }],
    domProps: {
      "value": (_vm.A_9a_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_14),
      expression: "A_9a_14"
    }],
    domProps: {
      "value": (_vm.A_9a_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5%征收率的服务、不动产和无形资产")]), _vm._v(" "), _c('td', [_vm._v("9b")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_1),
      expression: "A_9b_1"
    }],
    domProps: {
      "value": (_vm.A_9b_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_2),
      expression: "A_9b_2"
    }],
    domProps: {
      "value": (_vm.A_9b_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_3),
      expression: "A_9b_3"
    }],
    domProps: {
      "value": (_vm.A_9b_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_4),
      expression: "A_9b_4"
    }],
    domProps: {
      "value": (_vm.A_9b_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_5),
      expression: "A_9b_5"
    }],
    domProps: {
      "value": (_vm.A_9b_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_6),
      expression: "A_9b_6"
    }],
    domProps: {
      "value": (_vm.A_9b_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_7),
      expression: "A_9b_7"
    }],
    domProps: {
      "value": (_vm.A_9b_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_8),
      expression: "A_9b_8"
    }],
    domProps: {
      "value": (_vm.A_9b_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_9),
      expression: "A_9b_9"
    }],
    domProps: {
      "value": (_vm.A_9b_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_10),
      expression: "A_9b_10"
    }],
    domProps: {
      "value": (_vm.A_9b_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_11),
      expression: "A_9b_11"
    }],
    domProps: {
      "value": (_vm.A_9b_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_12),
      expression: "A_9b_12"
    }],
    domProps: {
      "value": (_vm.A_9b_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_13),
      expression: "A_9b_13"
    }],
    domProps: {
      "value": (_vm.A_9b_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_14),
      expression: "A_9b_14"
    }],
    domProps: {
      "value": (_vm.A_9b_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4%征收率")]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_1),
      expression: "A_10_1"
    }],
    domProps: {
      "value": (_vm.A_10_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_2),
      expression: "A_10_2"
    }],
    domProps: {
      "value": (_vm.A_10_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_3),
      expression: "A_10_3"
    }],
    domProps: {
      "value": (_vm.A_10_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_4),
      expression: "A_10_4"
    }],
    domProps: {
      "value": (_vm.A_10_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_5),
      expression: "A_10_5"
    }],
    domProps: {
      "value": (_vm.A_10_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_6),
      expression: "A_10_6"
    }],
    domProps: {
      "value": (_vm.A_10_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_7),
      expression: "A_10_7"
    }],
    domProps: {
      "value": (_vm.A_10_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_8),
      expression: "A_10_8"
    }],
    domProps: {
      "value": (_vm.A_10_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_9),
      expression: "A_10_9"
    }],
    domProps: {
      "value": (_vm.A_10_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_10),
      expression: "A_10_10"
    }],
    domProps: {
      "value": (_vm.A_10_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_11),
      expression: "A_10_11"
    }],
    domProps: {
      "value": (_vm.A_10_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_12),
      expression: "A_10_12"
    }],
    domProps: {
      "value": (_vm.A_10_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_13),
      expression: "A_10_13"
    }],
    domProps: {
      "value": (_vm.A_10_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_14),
      expression: "A_10_14"
    }],
    domProps: {
      "value": (_vm.A_10_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3%征收率的货物及加工修理修配劳务")]), _vm._v(" "), _c('td', [_vm._v("11")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_1),
      expression: "A_11_1"
    }],
    domProps: {
      "value": (_vm.A_11_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_2),
      expression: "A_11_2"
    }],
    domProps: {
      "value": (_vm.A_11_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_3),
      expression: "A_11_3"
    }],
    domProps: {
      "value": (_vm.A_11_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_4),
      expression: "A_11_4"
    }],
    domProps: {
      "value": (_vm.A_11_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_5),
      expression: "A_11_5"
    }],
    domProps: {
      "value": (_vm.A_11_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_6),
      expression: "A_11_6"
    }],
    domProps: {
      "value": (_vm.A_11_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_7),
      expression: "A_11_7"
    }],
    domProps: {
      "value": (_vm.A_11_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_8),
      expression: "A_11_8"
    }],
    domProps: {
      "value": (_vm.A_11_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_9),
      expression: "A_11_9"
    }],
    domProps: {
      "value": (_vm.A_11_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_10),
      expression: "A_11_10"
    }],
    domProps: {
      "value": (_vm.A_11_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_11),
      expression: "A_11_11"
    }],
    domProps: {
      "value": (_vm.A_11_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_12),
      expression: "A_11_12"
    }],
    domProps: {
      "value": (_vm.A_11_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_13),
      expression: "A_11_13"
    }],
    domProps: {
      "value": (_vm.A_11_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_14),
      expression: "A_11_14"
    }],
    domProps: {
      "value": (_vm.A_11_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3%征收率的服务、不动产和无形资产")]), _vm._v(" "), _c('td', [_vm._v("12")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_1),
      expression: "A_12_1"
    }],
    domProps: {
      "value": (_vm.A_12_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_2),
      expression: "A_12_2"
    }],
    domProps: {
      "value": (_vm.A_12_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_3),
      expression: "A_12_3"
    }],
    domProps: {
      "value": (_vm.A_12_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_4),
      expression: "A_12_4"
    }],
    domProps: {
      "value": (_vm.A_12_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_5),
      expression: "A_12_5"
    }],
    domProps: {
      "value": (_vm.A_12_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_6),
      expression: "A_12_6"
    }],
    domProps: {
      "value": (_vm.A_12_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_7),
      expression: "A_12_7"
    }],
    domProps: {
      "value": (_vm.A_12_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_8),
      expression: "A_12_8"
    }],
    domProps: {
      "value": (_vm.A_12_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_9),
      expression: "A_12_9"
    }],
    domProps: {
      "value": (_vm.A_12_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_10),
      expression: "A_12_10"
    }],
    domProps: {
      "value": (_vm.A_12_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_11),
      expression: "A_12_11"
    }],
    domProps: {
      "value": (_vm.A_12_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_12),
      expression: "A_12_12"
    }],
    domProps: {
      "value": (_vm.A_12_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_13),
      expression: "A_12_13"
    }],
    domProps: {
      "value": (_vm.A_12_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_14),
      expression: "A_12_14"
    }],
    domProps: {
      "value": (_vm.A_12_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("预征率 %")]), _vm._v(" "), _c('td', [_vm._v("13a")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_1),
      expression: "A_13a_1"
    }],
    domProps: {
      "value": (_vm.A_13a_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_2),
      expression: "A_13a_2"
    }],
    domProps: {
      "value": (_vm.A_13a_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_3),
      expression: "A_13a_3"
    }],
    domProps: {
      "value": (_vm.A_13a_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_4),
      expression: "A_13a_4"
    }],
    domProps: {
      "value": (_vm.A_13a_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_5),
      expression: "A_13a_5"
    }],
    domProps: {
      "value": (_vm.A_13a_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_6),
      expression: "A_13a_6"
    }],
    domProps: {
      "value": (_vm.A_13a_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_7),
      expression: "A_13a_7"
    }],
    domProps: {
      "value": (_vm.A_13a_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_8),
      expression: "A_13a_8"
    }],
    domProps: {
      "value": (_vm.A_13a_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_9),
      expression: "A_13a_9"
    }],
    domProps: {
      "value": (_vm.A_13a_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_10),
      expression: "A_13a_10"
    }],
    domProps: {
      "value": (_vm.A_13a_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_11),
      expression: "A_13a_11"
    }],
    domProps: {
      "value": (_vm.A_13a_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_12),
      expression: "A_13a_12"
    }],
    domProps: {
      "value": (_vm.A_13a_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_13),
      expression: "A_13a_13"
    }],
    domProps: {
      "value": (_vm.A_13a_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_14),
      expression: "A_13a_14"
    }],
    domProps: {
      "value": (_vm.A_13a_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("预征率 %")]), _vm._v(" "), _c('td', [_vm._v("13b")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_1),
      expression: "A_13b_1"
    }],
    domProps: {
      "value": (_vm.A_13b_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_2),
      expression: "A_13b_2"
    }],
    domProps: {
      "value": (_vm.A_13b_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_3),
      expression: "A_13b_3"
    }],
    domProps: {
      "value": (_vm.A_13b_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_4),
      expression: "A_13b_4"
    }],
    domProps: {
      "value": (_vm.A_13b_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_5),
      expression: "A_13b_5"
    }],
    domProps: {
      "value": (_vm.A_13b_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_6),
      expression: "A_13b_6"
    }],
    domProps: {
      "value": (_vm.A_13b_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_7),
      expression: "A_13b_7"
    }],
    domProps: {
      "value": (_vm.A_13b_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_8),
      expression: "A_13b_8"
    }],
    domProps: {
      "value": (_vm.A_13b_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_9),
      expression: "A_13b_9"
    }],
    domProps: {
      "value": (_vm.A_13b_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_10),
      expression: "A_13b_10"
    }],
    domProps: {
      "value": (_vm.A_13b_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_11),
      expression: "A_13b_11"
    }],
    domProps: {
      "value": (_vm.A_13b_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_12),
      expression: "A_13b_12"
    }],
    domProps: {
      "value": (_vm.A_13b_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_13),
      expression: "A_13b_13"
    }],
    domProps: {
      "value": (_vm.A_13b_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_14),
      expression: "A_13b_14"
    }],
    domProps: {
      "value": (_vm.A_13b_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("预征率 %")]), _vm._v(" "), _c('td', [_vm._v("13c")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_1),
      expression: "A_13c_1"
    }],
    domProps: {
      "value": (_vm.A_13c_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_2),
      expression: "A_13c_2"
    }],
    domProps: {
      "value": (_vm.A_13c_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_3),
      expression: "A_13c_3"
    }],
    domProps: {
      "value": (_vm.A_13c_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_4),
      expression: "A_13c_4"
    }],
    domProps: {
      "value": (_vm.A_13c_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_5),
      expression: "A_13c_5"
    }],
    domProps: {
      "value": (_vm.A_13c_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_6),
      expression: "A_13c_6"
    }],
    domProps: {
      "value": (_vm.A_13c_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_7),
      expression: "A_13c_7"
    }],
    domProps: {
      "value": (_vm.A_13c_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_8),
      expression: "A_13c_8"
    }],
    domProps: {
      "value": (_vm.A_13c_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_9),
      expression: "A_13c_9"
    }],
    domProps: {
      "value": (_vm.A_13c_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_10),
      expression: "A_13c_10"
    }],
    domProps: {
      "value": (_vm.A_13c_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_11),
      expression: "A_13c_11"
    }],
    domProps: {
      "value": (_vm.A_13c_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_12),
      expression: "A_13c_12"
    }],
    domProps: {
      "value": (_vm.A_13c_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_13),
      expression: "A_13c_13"
    }],
    domProps: {
      "value": (_vm.A_13c_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_14),
      expression: "A_13c_14"
    }],
    domProps: {
      "value": (_vm.A_13c_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("其中：即征即退项目")]), _vm._v(" "), _c('td', [_vm._v("即征即退货物及加工修理修配劳务")]), _vm._v(" "), _c('td', [_vm._v("14")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_1),
      expression: "A_14_1"
    }],
    domProps: {
      "value": (_vm.A_14_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_2),
      expression: "A_14_2"
    }],
    domProps: {
      "value": (_vm.A_14_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_3),
      expression: "A_14_3"
    }],
    domProps: {
      "value": (_vm.A_14_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_4),
      expression: "A_14_4"
    }],
    domProps: {
      "value": (_vm.A_14_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_5),
      expression: "A_14_5"
    }],
    domProps: {
      "value": (_vm.A_14_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_6),
      expression: "A_14_6"
    }],
    domProps: {
      "value": (_vm.A_14_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_7),
      expression: "A_14_7"
    }],
    domProps: {
      "value": (_vm.A_14_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_8),
      expression: "A_14_8"
    }],
    domProps: {
      "value": (_vm.A_14_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_9),
      expression: "A_14_9"
    }],
    domProps: {
      "value": (_vm.A_14_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_10),
      expression: "A_14_10"
    }],
    domProps: {
      "value": (_vm.A_14_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_11),
      expression: "A_14_11"
    }],
    domProps: {
      "value": (_vm.A_14_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_12),
      expression: "A_14_12"
    }],
    domProps: {
      "value": (_vm.A_14_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_13),
      expression: "A_14_13"
    }],
    domProps: {
      "value": (_vm.A_14_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_14),
      expression: "A_14_14"
    }],
    domProps: {
      "value": (_vm.A_14_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("即征即退服务、不动产和无形资产")]), _vm._v(" "), _c('td', [_vm._v("15")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_1),
      expression: "A_15_1"
    }],
    domProps: {
      "value": (_vm.A_15_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_2),
      expression: "A_15_2"
    }],
    domProps: {
      "value": (_vm.A_15_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_3),
      expression: "A_15_3"
    }],
    domProps: {
      "value": (_vm.A_15_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_4),
      expression: "A_15_4"
    }],
    domProps: {
      "value": (_vm.A_15_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_5),
      expression: "A_15_5"
    }],
    domProps: {
      "value": (_vm.A_15_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_6),
      expression: "A_15_6"
    }],
    domProps: {
      "value": (_vm.A_15_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_7),
      expression: "A_15_7"
    }],
    domProps: {
      "value": (_vm.A_15_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_8),
      expression: "A_15_8"
    }],
    domProps: {
      "value": (_vm.A_15_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_9),
      expression: "A_15_9"
    }],
    domProps: {
      "value": (_vm.A_15_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_10),
      expression: "A_15_10"
    }],
    domProps: {
      "value": (_vm.A_15_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_11),
      expression: "A_15_11"
    }],
    domProps: {
      "value": (_vm.A_15_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_12),
      expression: "A_15_12"
    }],
    domProps: {
      "value": (_vm.A_15_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_13),
      expression: "A_15_13"
    }],
    domProps: {
      "value": (_vm.A_15_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_14),
      expression: "A_15_14"
    }],
    domProps: {
      "value": (_vm.A_15_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("三、免抵退税")]), _vm._v(" "), _c('td', [_vm._v("货物及加工修理修配劳务")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("16")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_1),
      expression: "A_16_1"
    }],
    domProps: {
      "value": (_vm.A_16_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_2),
      expression: "A_16_2"
    }],
    domProps: {
      "value": (_vm.A_16_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_3),
      expression: "A_16_3"
    }],
    domProps: {
      "value": (_vm.A_16_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_4),
      expression: "A_16_4"
    }],
    domProps: {
      "value": (_vm.A_16_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_5),
      expression: "A_16_5"
    }],
    domProps: {
      "value": (_vm.A_16_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_6),
      expression: "A_16_6"
    }],
    domProps: {
      "value": (_vm.A_16_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_7),
      expression: "A_16_7"
    }],
    domProps: {
      "value": (_vm.A_16_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_8),
      expression: "A_16_8"
    }],
    domProps: {
      "value": (_vm.A_16_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_9),
      expression: "A_16_9"
    }],
    domProps: {
      "value": (_vm.A_16_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_10),
      expression: "A_16_10"
    }],
    domProps: {
      "value": (_vm.A_16_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_11),
      expression: "A_16_11"
    }],
    domProps: {
      "value": (_vm.A_16_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_12),
      expression: "A_16_12"
    }],
    domProps: {
      "value": (_vm.A_16_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_13),
      expression: "A_16_13"
    }],
    domProps: {
      "value": (_vm.A_16_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_14),
      expression: "A_16_14"
    }],
    domProps: {
      "value": (_vm.A_16_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("服务、不动产和无形资产")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("17")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_1),
      expression: "A_17_1"
    }],
    domProps: {
      "value": (_vm.A_17_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_2),
      expression: "A_17_2"
    }],
    domProps: {
      "value": (_vm.A_17_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_3),
      expression: "A_17_3"
    }],
    domProps: {
      "value": (_vm.A_17_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_4),
      expression: "A_17_4"
    }],
    domProps: {
      "value": (_vm.A_17_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_5),
      expression: "A_17_5"
    }],
    domProps: {
      "value": (_vm.A_17_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_6),
      expression: "A_17_6"
    }],
    domProps: {
      "value": (_vm.A_17_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_7),
      expression: "A_17_7"
    }],
    domProps: {
      "value": (_vm.A_17_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_8),
      expression: "A_17_8"
    }],
    domProps: {
      "value": (_vm.A_17_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_9),
      expression: "A_17_9"
    }],
    domProps: {
      "value": (_vm.A_17_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_10),
      expression: "A_17_10"
    }],
    domProps: {
      "value": (_vm.A_17_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_11),
      expression: "A_17_11"
    }],
    domProps: {
      "value": (_vm.A_17_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_12),
      expression: "A_17_12"
    }],
    domProps: {
      "value": (_vm.A_17_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_13),
      expression: "A_17_13"
    }],
    domProps: {
      "value": (_vm.A_17_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_14),
      expression: "A_17_14"
    }],
    domProps: {
      "value": (_vm.A_17_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("四、免税")]), _vm._v(" "), _c('td', [_vm._v("货物及加工修理修配劳务")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("18")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_1),
      expression: "A_18_1"
    }],
    domProps: {
      "value": (_vm.A_18_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_2),
      expression: "A_18_2"
    }],
    domProps: {
      "value": (_vm.A_18_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_3),
      expression: "A_18_3"
    }],
    domProps: {
      "value": (_vm.A_18_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_4),
      expression: "A_18_4"
    }],
    domProps: {
      "value": (_vm.A_18_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_5),
      expression: "A_18_5"
    }],
    domProps: {
      "value": (_vm.A_18_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_6),
      expression: "A_18_6"
    }],
    domProps: {
      "value": (_vm.A_18_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_7),
      expression: "A_18_7"
    }],
    domProps: {
      "value": (_vm.A_18_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_8),
      expression: "A_18_8"
    }],
    domProps: {
      "value": (_vm.A_18_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_9),
      expression: "A_18_9"
    }],
    domProps: {
      "value": (_vm.A_18_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_10),
      expression: "A_18_10"
    }],
    domProps: {
      "value": (_vm.A_18_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_11),
      expression: "A_18_11"
    }],
    domProps: {
      "value": (_vm.A_18_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_12),
      expression: "A_18_12"
    }],
    domProps: {
      "value": (_vm.A_18_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_13),
      expression: "A_18_13"
    }],
    domProps: {
      "value": (_vm.A_18_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_14),
      expression: "A_18_14"
    }],
    domProps: {
      "value": (_vm.A_18_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("服务、不动产和无形资产")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("19")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_1),
      expression: "A_19_1"
    }],
    domProps: {
      "value": (_vm.A_19_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_2),
      expression: "A_19_2"
    }],
    domProps: {
      "value": (_vm.A_19_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_3),
      expression: "A_19_3"
    }],
    domProps: {
      "value": (_vm.A_19_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_4),
      expression: "A_19_4"
    }],
    domProps: {
      "value": (_vm.A_19_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_5),
      expression: "A_19_5"
    }],
    domProps: {
      "value": (_vm.A_19_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_6),
      expression: "A_19_6"
    }],
    domProps: {
      "value": (_vm.A_19_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_7),
      expression: "A_19_7"
    }],
    domProps: {
      "value": (_vm.A_19_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_8),
      expression: "A_19_8"
    }],
    domProps: {
      "value": (_vm.A_19_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_9),
      expression: "A_19_9"
    }],
    domProps: {
      "value": (_vm.A_19_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_10),
      expression: "A_19_10"
    }],
    domProps: {
      "value": (_vm.A_19_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_11),
      expression: "A_19_11"
    }],
    domProps: {
      "value": (_vm.A_19_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_12),
      expression: "A_19_12"
    }],
    domProps: {
      "value": (_vm.A_19_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_13),
      expression: "A_19_13"
    }],
    domProps: {
      "value": (_vm.A_19_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_14),
      expression: "A_19_14"
    }],
    domProps: {
      "value": (_vm.A_19_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_14 = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(7)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "18"
    }
  }, [_vm._v("增值税纳税申报表附列资料（一）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "font-size": "12px"
    },
    attrs: {
      "colspan": "18"
    }
  }, [_vm._v("（本期销售情况明细）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "18"
    }
  }, [_vm._v("税款所属时间： 年 月 日 至 年 月 日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "18"
    }
  }, [_vm._v("纳税人名称：（公章）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3",
      "colspan": "4"
    }
  }, [_vm._v("项目及栏次")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("开具其他发票")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("未开具发票")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("纳税检查调整")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("合计")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("服务、不动产和无形资产扣除项目本期实际扣除金额")]), _vm._v(" "), _c('td', [_vm._v("扣除后")]), _vm._v(" "), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("销售额")]), _vm._v(" "), _c('td', [_vm._v("销项(应纳)税额")]), _vm._v(" "), _c('td', [_vm._v("销售额")]), _vm._v(" "), _c('td', [_vm._v("销项(应纳)税额")]), _vm._v(" "), _c('td', [_vm._v("销售额")]), _vm._v(" "), _c('td', [_vm._v("销项(应纳)税额")]), _vm._v(" "), _c('td', [_vm._v("销售额")]), _vm._v(" "), _c('td', [_vm._v("销项(应纳)税额")]), _vm._v(" "), _c('td', [_vm._v("销售额 I（总销售收入销售额+纳税检查+视同销售）")]), _vm._v(" "), _c('td', [_vm._v("销项(应纳)税额")]), _vm._v(" "), _c('td', [_vm._v("价税合计")]), _vm._v(" "), _c('td', [_vm._v("13")]), _vm._v(" "), _c('td', [_vm._v("14")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_vm._v("9=1+3+5+7")]), _vm._v(" "), _c('td', [_vm._v("10=2+4+6+8")]), _vm._v(" "), _c('td', [_vm._v("11=9+10")]), _vm._v(" "), _c('td', [_vm._v("12")]), _vm._v(" "), _c('td', [_vm._v("13=11-12")]), _vm._v(" "), _c('td', [_vm._v("14=13÷(100%+税率或征收率)×税率或征收率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("1、开具增值税专用发票、开具其他发票两个栏次根据1.1销项发票取数台账填写，区分发票类型（专票或普票）结合对应的申报行次填写。（包含免税开票情形）")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("2、根据总销售收入台账减去销项发票取数台账加上视同销售台账得到的金额，按照对应的申报表栏次填写未开具发票销售额及销项税额")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("3、纳税检查调整栏次根据1.3纳税检查调整台账中的数据，按照对应的申报表栏次填写")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("4.即征即退行次数据根据1.5即征即退管理台账的金额填写")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("5.服务、不动产和无形资产扣除项目本期实际扣除金额根据附表三的数据填写，具体公式已经在表格里")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24a079d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nssb/table1.vue
// module id = 713
// module chunks = 1